export default __webpack_public_path__ + "super_success-f3d47b71d13f12f32d0c57f5edbe50b3.mp3";